export const monthsArray = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

export const firstDay = (month, filterYear) => {
  // console.log('Ano: ', filterYear);
  return new Date(filterYear, month, 1).toISOString().substr(0, 10);
};

export const lastDay = (month, filterYear) => {
  return new Date(filterYear, month + 1, 0).toISOString().substr(0, 10);
};

export const convertDate = (date) => {
  const newDate = new Date(date);

  let day = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  if (day < 10) day = '0' + day;
  if (month < 10) month = '0' + month;

  return `${year}-${month}-${day}`;
};

export const convertDate2 = (date) => {
  if (!date) return '';
  
  const year = date.substr(0, 4);
  const month = date.substr(5, 2);
  const day = date.substr(8, 2);
  return `${day}/${month}/${year}`;
};

export const convertDate3 = (date) => {
  const newDate = new Date(date);

  let seconds = newDate.getSeconds();
  let minutes = newDate.getMinutes();
  let hours = newDate.getHours();
  let day = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  if (seconds < 10) seconds = '0' + seconds;
  if (minutes < 10) minutes = '0' + minutes;
  if (hours < 10) hours = '0' + hours;
  if (day < 10) day = '0' + day;
  if (month < 10) month = '0' + month;

  return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
};

export const getMinDateFromReconciliation = (reconciliationDate) => {
  if (!reconciliationDate) return null;

  const date = new Date(reconciliationDate);
  date.setDate(date.getDate() + 1); // Set to the next day
  return convertDate(date);
};

// Formats a date string or Date object into 'YYYY-MM-DD' suitable for date inputs, using UTC to avoid timezone issues.
export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  try {
    // Handle cases where dateString is already in YYYY-MM-DD format
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return dateString;
    }
    
    // Create a date object assuming the input string is in local time, then use UTC methods
    let date;
    
    // If it's a Date object or timestamp from API
    if (dateString instanceof Date || dateString.includes('T')) {
      date = new Date(dateString);
    }
    // If it's in DD/MM/YYYY format
    else if (dateString.includes('/')) {
      const parts = dateString.split('/');
      date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    }
    // If it's in YYYYMMDD format (from OFX)
    else if (dateString.length >= 8 && !dateString.includes('-')) {
      const year = dateString.substr(0, 4);
      const month = dateString.substr(4, 2);
      const day = dateString.substr(6, 2);
      date = new Date(`${year}-${month}-${day}`);
    }
    else {
      // Try default parsing
      date = new Date(dateString);
    }

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      console.error('Invalid date provided to formatDateForInput:', dateString);
      return ''; // Return empty string for invalid dates
    }

    const year = date.getFullYear();
    // getMonth is 0-indexed, so add 1
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error formatting date:', dateString, error);
    return ''; // Return empty string on error
  }
};
